export const buttonSymbolOptions = [
  // Font Awesome Solid (fas) - Document & Questionnaire Themed
  'fas fa-file',
  'fas fa-file-circle-check',
  'fas fa-file-circle-question',
  'fas fa-file-pen',
  'fas fa-file-signature',
  'fas fa-file-invoice',
  'fas fa-folder',
  'fas fa-folder-open',
  'fas fa-book',
  'fas fa-book-open',
  'fas fa-address-book',
  'fas fa-clipboard',
  'fas fa-clipboard-check',
  'fas fa-clipboard-list',
  'fas fa-pen',
  'fas fa-pen-to-square',
  'fas fa-envelope',
  'fas fa-question-circle',
  'fas fa-circle-check',
  'fas fa-tasks',
  'fas fa-list',
  'fas fa-list-check',
  'fas fa-calendar',
  'fas fa-calendar-check',
  'fas fa-database',
  'fas fa-chart-bar',
  'fas fa-chart-pie',
  'fas fa-table',
  'fas fa-id-card',
  'fas fa-keyboard',
  'fas fa-user',
  'fas fa-users',
  'fas fa-comments',
  'fas fa-comment-dots',
  'fas fa-lightbulb',
  'fas fa-bolt',
  'fas fa-folder-plus',
  'fas fa-download',
  'fas fa-upload',
  'fas fa-print',
  'fas fa-save',
  'fas fa-lock',
  'fas fa-unlock',

  // Font Awesome Regular (far) 
  'far fa-calendar',
  'far fa-clipboard',
  'far fa-comment',
  'far fa-lightbulb',
];
